import { type AnyAction, combineReducers } from 'redux';

import {
    setColorShuffleDataForSlide,
    setColorShuffleIndexForSlide,
    setTemplateColorShuffleIndex,
    setTemplateColorShufflePalettes,
} from 'js/src/data/color-shuffle/color-shuffle-actions';
import type { ColorShuffleInfo } from 'js/src/data/color-shuffle/color-shuffle-types';

const NO_SHUFFLE_INDEXES: Readonly<Record<string, number>> = {};
const NO_SHUFFLE_DATA: Readonly<Record<string, ColorShuffleInfo>> = {};

const withValue = <Value>(
    state: Readonly<Record<string, Value>>,
    key: string,
    value: Value,
): Readonly<Record<string, Value>> =>
    Object.prototype.hasOwnProperty.call(state, key) && state[key] === value
        ? state
        : { ...state, [key]: value };

export function color_shuffle_index(state = NO_SHUFFLE_INDEXES, action: AnyAction) {
    if (setColorShuffleIndexForSlide.match(action)) {
        return withValue(state, action.payload.sceneId, action.payload.colorShuffleIndex);
    }
    return state;
}

export function color_shuffle_data(state = NO_SHUFFLE_DATA, action: AnyAction) {
    if (setColorShuffleDataForSlide.match(action)) {
        return withValue(state, action.payload.sceneId, action.payload.colorShuffleInfo);
    }
    return state;
}

export function template_color_shuffle_palettes(state: number[][] = [], action: AnyAction) {
    if (setTemplateColorShufflePalettes.match(action)) {
        return action.payload.palettes;
    }
    return state;
}

export function template_color_shuffle_index(state = 0, action: AnyAction) {
    if (setTemplateColorShuffleIndex.match(action)) {
        return action.payload.colorShuffleIndex;
    }
    return state;
}

export const color_shuffle = combineReducers({
    color_shuffle_data,
    color_shuffle_index,
    template_color_shuffle_palettes,
    template_color_shuffle_index,
});
